const reloadWindow = () => {
  window.location.reload();
};

export { reloadWindow };
